import { APP_MODULES } from 'constants/appModules';
import { eddrModules } from 'constants/eddrModules';
import { LESSONS_LEARNT_MODULES, lessonsLearntModules } from 'constants/lessonsLearntModule';
import { PATHS } from 'constants/paths';
import { userAdminModules } from 'constants/userAdminModules';
import { isKeyInObject, ObjectKeys } from 'helpers/ts-helpers';

const eddrTabs = eddrModules.map(eddrModule => ({
  name: eddrModule,
  displayedName: `header.pages.${eddrModule}`,
  path: PATHS[eddrModule],
}));

const lessonLearntTabs = lessonsLearntModules
  .filter(module => module !== LESSONS_LEARNT_MODULES.LESSONS_LEARNT_VIEW)
  .map(lessonLearntModule => ({
    name: lessonLearntModule,
    displayedName: `header.pages.${lessonLearntModule}`,
    path: PATHS[lessonLearntModule],
  }));

const userAdminTabs = userAdminModules.map(module => ({
  name: module,
  displayedName: `header.pages.${module}`,
  path: PATHS[module],
}));

export const modulesWithTabs = {
  [APP_MODULES.EDDR]: eddrTabs,
  [APP_MODULES.LESSONS_LEARNT]: lessonLearntTabs,
  [APP_MODULES.USER_ADMIN]: userAdminTabs,
} as const;

export const tabsModulesList = ObjectKeys(modulesWithTabs);

export type TAB_MODULES = (typeof tabsModulesList)[number];

export const getTabsByCurrentModule = (currentModule?: APP_MODULES) => {
  if (currentModule === undefined) {
    return undefined;
  }

  return isKeyInObject(currentModule, modulesWithTabs) ? modulesWithTabs[currentModule] : undefined;
};

export const formatWellName = (wellName: string | undefined) => {
  return wellName?.replace(/[()]/g, '').replace(/\s+/g, '-');
};

export const MODULES_WITH_REFRESH = [APP_MODULES.LESSONS_LEARNT];
